import { Component, HostListener, inject, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';
import { Router } from '@angular/router';
import { AdminAuthService } from '../../services/admin/admin-auth.service';
import {
  AdminLoginRequest,
  AdminLoginResponse
} from '../../services/admin/models/admin-auth-model';
import { ValidateCustomEmail } from '../shared/validators/type-validators';
import { HeaderTitleService } from '../home/main/components/header-mobile/title-behavior-service/header-title.service';
import { Subject, takeUntil } from 'rxjs';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';

@Component({
  selector: 'app-admin-auth',
  templateUrl: './admin-auth.component.html',
  styleUrls: ['./admin-auth.component.scss']
})
export class AdminAuthComponent implements OnInit {
  hide = true;
  loginForm: UntypedFormGroup;
  incorrectData = false;
  mobileScreen: boolean;
  screenWidth: number;
  loading: boolean = false;
  account: AccountInfo;

  private destroy$ = new Subject<void>();
  private msalBroadcast = inject(MsalBroadcastService);

  constructor(
    private fb: UntypedFormBuilder,
    private adminAuthService: AdminAuthService,
    private router: Router,
    private headerTitleService: HeaderTitleService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.getScreenSize();
    this.headerTitleService.setTitle('Admin Login');

    this.msalBroadcast.inProgress$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status) => {
        this.loading =
          status === InteractionStatus.Login ||
          status === InteractionStatus.AcquireToken;
      });

    this.adminAuthService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.loading = false;
        }
      });
  }

  async submit(): Promise<void> {
    try {
      const loginResult = await this.adminAuthService.login();
      this.account = loginResult.account;
      console.log('Account: ', this.account);
    } catch (error) {
      console.log('Login error: ', error);
      this.notificationService.error(error as string);
      this.incorrectData = true;
    }
  }

  @HostListener('window:resize')
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    this.mobileScreen = this.screenWidth <= 576;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
